import Swiper from 'swiper'
import { Navigation, Autoplay } from 'swiper/modules'

const swiperSlider = document.querySelectorAll('.swiper-slider')

function initSwiperSlider() {
    if (!swiperSlider.length) return
    swiperSlider.forEach((swiperWrapper) => {
        const wideSlider = swiperWrapper.dataset.wideSlider === 'true'
        const autoPlay = swiperWrapper.dataset.autoPlay === 'true'
        const swiper = new Swiper(swiperWrapper, {
            modules: [Navigation, Autoplay],
            navigation: {
                nextEl: swiperWrapper.nextElementSibling.querySelector('.swiper-button-next'),
                prevEl: swiperWrapper.nextElementSibling.querySelector('.swiper-button-prev'),
            },
            speed: 500,
            autoplay: autoPlay,
            loop: true,
            centeredSlides: wideSlider,
            slidesPerView: 'auto',
        })
        swiperWrapper.swiper = swiper
    })
}

initSwiperSlider()
